module.exports = __webpack_public_path__ + "static/img/LCP_eXcYte_final.f3b5326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LCP_eXcYte_final.png
// module id = 484
// module chunks = 1